import React from 'react';
import { backendServerInvestor } from '../../../variable';
import { message } from 'antd';
import qs from 'qs';
import { get } from '../../../utils/fetch';

//转让协议文件模板
class TransferFile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sellerId: '',
      buyerId: '',
      amount: '',
      percentage: '',
      projectName: '',
      investmentAmount: '',
      estimatedAnnualizedIncome: '',
      address: '',
      enterpriseName: ''
    };
  }

  componentDidMount() {
    //fetch something
    const { productId, access_token } = qs.parse(
      this.props.location.search.slice(1)
    );
    if (productId && access_token) {
      let url = `${backendServerInvestor}/app/transferPlant/transferProtocolData`;
      get(url, { productId }, access_token).then(result => {
        //Success or Fail
        if (result.success) {
          const { data } = result;
          this.setState({
            sellerId: data.sellerId,
            buyerId: data.buyerId,
            amount: data.amount,
            percentage: data.percentage,
            projectName: data.projectName,
            investmentAmount: data.investmentAmount,
            estimatedAnnualizedIncome: data.estimatedAnnualizedIncome,
            address: data.address,
            enterpriseName: data.enterpriseName
          });
        }
      });
    } else {
      message.error('无效的入参', 2);
    }
  }

  render() {
    const {
      sellerId,
      buyerId,
      amount,
      percentage,
      projectName,
      investmentAmount,
      estimatedAnnualizedIncome,
      address,
      enterpriseName
    } = this.state;
    return (
      <div className="file-container" style={ { backgroundColor: '#fff' } }>
        <div><p style={ { margin: '0pt', orphans: 0, textAlign: 'center', widows: 0 } }><span style={ {
          backgroundColor: '#ffffff',
          fontFamily: '仿宋',
          fontSize: '18pt',
          fontWeight: 'bold'
        } }>电站份额转让协议</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '11pt', fontWeight: 'bold' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>甲方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>（</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>转让方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>）</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>：{sellerId}</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>身份证号码：</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>乙方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>（</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>受让方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>）</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>：{buyerId}</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>身份证号码：</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>丙方：杭州能信科技有限公司</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>法定代表人：程立叶</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>住所地：浙江省杭州市余杭区五常街道溪望路1号310-1室{' '}</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>丙方为一家在中国境内合法设立的科技企业，旗下运营“</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>一度店</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>”</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>应用软件（</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>“</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>平台</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>”</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>），平台</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>为</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>光伏</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站项目提供</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>信息采集披露、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>交易撮合等综合居间服务。</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>甲方是平台个人注册用户，</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>已</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>持有</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>但有意转让其持有的光</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>伏电站</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>项目认购份额</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>。</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>乙方是平台个人注册用户，有意用其合法持有的自有资金</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>受让甲方欲出让的</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>光伏电站</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>项目份额</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>。</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>甲、乙、丙三方就</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>甲方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>转让其现持有的光伏电站份额给</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>达成如下协议，</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>以</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>兹</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>共同遵守。</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第1条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>拟转让</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>项目基本情况</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>1、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>项目具体地址：</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>_________________<span style={{ textDecoration: 'underline' }}>{address}</span>______________________</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>2、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>项目名称：</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>_____________<span style={{ textDecoration: 'underline' }}>{projectName}</span>________________</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>3</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站协定价值：</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>______<span style={{ textDecoration: 'underline' }}>
                {(investmentAmount || 0) / 100 / 10000}
              </span>________</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>万元</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>4</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站预期发电回报率：</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>_____<span style={{ textDecoration: 'underline' }}>
                {estimatedAnnualizedIncome}
              </span>_____%</span><span
            style={ {
              backgroundColor: '#ffffff',
              fontFamily: '仿宋',
              fontSize: '10pt'
            } }>（年化收益仅供参考，可能会因政策、法律及其他不可抗力原因产生偏差）</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>5</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、电站运营维护方：</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>_______________<span style={{ textDecoration: 'underline' }}>
                {enterpriseName}
              </span>_________________</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第2条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>甲方拟转让份额</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>1、</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>转让份额价款：</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>___________</span>
            <span style={{ textDecoration: 'underline' }}>
                {((amount || 0) / 100).toFixed(2)}（元）
              </span>
            <span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>____</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>2、</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>所占电站份额比例：</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>______<span style={{ textDecoration: 'underline' }}>
                {((percentage || 0) * 100).toFixed(2)}%
              </span>_______</span></p>
          <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第3条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>乙方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>权利义务</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>1、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>方同意注册成为丙方平台用户，授权丙方从支付宝平台获取</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>方的相关身份信息用作</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>方注册信息。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>2、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>保证：</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>受让</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>项目</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>所支付的转让款</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>资金</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>为</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>合法自有资金。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>3、</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>乙方应认真阅读电站项目第一手出让（从电站运营维护方转让给平台个人用户）的《认购及居间服务协议》，确保</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>已经清楚了解</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>项目详情</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>愿意接受受让电站份额所需承担的义务</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，知晓</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>项目存在潜在的风险并愿意承担该风险。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>4、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>作为丙方注册用户，将遵守丙方的《平台服务协议》、《用户注册协议</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>（</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>个人</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>）</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>》</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>5、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>方受让甲方出让的电站份额，按照</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>平台</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>app</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、小程序引导流程，支付转让价款。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>6、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方受让份额后，</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>可以通过平台</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>app</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>实时知晓电站实时功率、今日</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>/</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>累计发电量、今日收</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>益等电站详情。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>7、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方受让电站份额后，</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>须委托</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站运营维护方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>代为运营管理电站并支付管理服务费，管理服务费中将包含：房屋租赁费、保险费、维护费用等其他必要费用</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>（</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>份额受让之日至结算日不足一月的，按实际持有天数计算</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>）</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 14.6pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>8</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>、乙方同意，受让电站份额后以其持有的份额比例向电站运营维护方支付管理服务费（</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>代缴税费、代为购买保险、代为租赁屋顶</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>等</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>费用将从</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站运营维护方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>收取的管理</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>服务费中支取，若当月收取的管理服务费为</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>0</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>的，上述费用由</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站运营维护方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>承担</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>），</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>管理服务费计算方式（以“月”为时间单位</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>份额受让之日至结算日不足一月的，按实际持有天数计算</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>）：</span></p>
          <p style={ { margin: '0pt 0pt 0pt 14.6pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span>
          </p>
          <table cellSpacing={ 0 } cellPadding={ 0 } style={ { borderCollapse: 'collapse', marginLeft: '18.2pt' } }>
            <tbody>
            <tr>
              <td style={ {
                borderBottomColor: '#000000',
                borderBottomStyle: 'solid',
                borderBottomWidth: '0.75pt',
                borderLeftColor: '#000000',
                borderLeftStyle: 'solid',
                borderLeftWidth: '0.75pt',
                borderRightColor: '#000000',
                borderRightStyle: 'solid',
                borderRightWidth: '0.75pt',
                borderTopColor: '#000000',
                borderTopStyle: 'solid',
                borderTopWidth: '0.75pt',
                paddingLeft: '5.03pt',
                paddingRight: '5.03pt',
                verticalAlign: 'top',
                width: '126.3pt'
              } }>
                <p style={ { margin: '0pt', orphans: 0, textAlign: 'center', widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>计算条件</span></p></td>
              <td style={ {
                borderBottomColor: '#000000',
                borderBottomStyle: 'solid',
                borderBottomWidth: '0.75pt',
                borderLeftColor: '#000000',
                borderLeftStyle: 'solid',
                borderLeftWidth: '0.75pt',
                borderRightColor: '#000000',
                borderRightStyle: 'solid',
                borderRightWidth: '0.75pt',
                borderTopColor: '#000000',
                borderTopStyle: 'solid',
                borderTopWidth: '0.75pt',
                paddingLeft: '5.03pt',
                paddingRight: '5.03pt',
                verticalAlign: 'top',
                width: '233.35pt'
              } }>
                <p style={ { margin: '0pt', orphans: 0, textAlign: 'center', widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>管理费计算方式</span></p></td>
            </tr>
            <tr>
              <td style={ {
                borderBottomColor: '#000000',
                borderBottomStyle: 'solid',
                borderBottomWidth: '0.75pt',
                borderLeftColor: '#000000',
                borderLeftStyle: 'solid',
                borderLeftWidth: '0.75pt',
                borderRightColor: '#000000',
                borderRightStyle: 'solid',
                borderRightWidth: '0.75pt',
                borderTopColor: '#000000',
                borderTopStyle: 'solid',
                borderTopWidth: '0.75pt',
                paddingLeft: '5.03pt',
                paddingRight: '5.03pt',
                verticalAlign: 'top',
                width: '126.3pt'
              } }>
                <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>当月发电年化回报率</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>≤</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>6</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>% </span></p></td>
              <td style={ {
                borderBottomColor: '#000000',
                borderBottomStyle: 'solid',
                borderBottomWidth: '0.75pt',
                borderLeftColor: '#000000',
                borderLeftStyle: 'solid',
                borderLeftWidth: '0.75pt',
                borderRightColor: '#000000',
                borderRightStyle: 'solid',
                borderRightWidth: '0.75pt',
                borderTopColor: '#000000',
                borderTopStyle: 'solid',
                borderTopWidth: '0.75pt',
                paddingLeft: '5.03pt',
                paddingRight: '5.03pt',
                verticalAlign: 'top',
                width: '233.35pt'
              } }>
                <p style={ { margin: '0pt', orphans: 0, textAlign: 'center', widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>0%</span></p></td>
            </tr>
            <tr>
              <td style={ {
                borderBottomColor: '#000000',
                borderBottomStyle: 'solid',
                borderBottomWidth: '0.75pt',
                borderLeftColor: '#000000',
                borderLeftStyle: 'solid',
                borderLeftWidth: '0.75pt',
                borderRightColor: '#000000',
                borderRightStyle: 'solid',
                borderRightWidth: '0.75pt',
                borderTopColor: '#000000',
                borderTopStyle: 'solid',
                borderTopWidth: '0.75pt',
                paddingLeft: '5.03pt',
                paddingRight: '5.03pt',
                verticalAlign: 'top',
                width: '126.3pt'
              } }>
                <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>当月发电年化回报率</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>＞</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>6</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>% </span></p></td>
              <td style={ {
                borderBottomColor: '#000000',
                borderBottomStyle: 'solid',
                borderBottomWidth: '0.75pt',
                borderLeftColor: '#000000',
                borderLeftStyle: 'solid',
                borderLeftWidth: '0.75pt',
                borderRightColor: '#000000',
                borderRightStyle: 'solid',
                borderRightWidth: '0.75pt',
                borderTopColor: '#000000',
                borderTopStyle: 'solid',
                borderTopWidth: '0.75pt',
                paddingLeft: '5.03pt',
                paddingRight: '5.03pt',
                verticalAlign: 'top',
                width: '233.35pt'
              } }>
                <p style={ { margin: '0pt', orphans: 0, textAlign: 'center', widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>(</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>月收益</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>-</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>转让份额价款</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>×</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>6</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>%</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>÷</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>12</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>)</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>×</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>95</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>%</span></p></td>
            </tr>
            <tr>
              <td colSpan={ 2 } style={ {
                borderBottomColor: '#000000',
                borderBottomStyle: 'solid',
                borderBottomWidth: '0.75pt',
                borderLeftColor: '#000000',
                borderLeftStyle: 'solid',
                borderLeftWidth: '0.75pt',
                borderRightColor: '#000000',
                borderRightStyle: 'solid',
                borderRightWidth: '0.75pt',
                borderTopColor: '#000000',
                borderTopStyle: 'solid',
                borderTopWidth: '0.75pt',
                paddingLeft: '5.03pt',
                paddingRight: '5.03pt',
                verticalAlign: 'top',
                width: '370.45pt'
              } }>
                <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>注：</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>1</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>月收益</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>=</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>每月电站售电收益×</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方受让份额</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>比例</span></p>
                <p style={ { margin: '0pt', orphans: 0, widows: 0 } }><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;&nbsp; </span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }> </span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>2</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、当月发电年化回报率</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>=</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>月收益×</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>12</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>÷</span><span
                  style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站协定价值</span></p></td>
            </tr>
            <tr style={ { height: '0pt' } }>
              <td style={ { width: '137.1pt', border: 'none' } }/>
              <td style={ { width: '244.15pt', border: 'none' } }/>
            </tr>
            </tbody>
          </table>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>9</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、乙方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>须</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>通过支付宝平台</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>支付转让价款</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，自付款之日起按照</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>转让</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>份额获得电站</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>产权：若</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>于当日</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>1</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>：</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>00-24</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>：</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>00</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>之间支付</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>份额转让款</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，则于</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>T+1</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>起计算</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>份额</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>收益；若</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>于当日</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>0:00-1:00</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>之间支付</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>份额转让款</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，则于当日开始计算</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>份额</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>收益（非工作日顺延至工作日）。</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站运营维护方将按月结算电站收益，在</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>下月末将收益存入丙方指定银行监管账户。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>10</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>、乙方受让成为光伏电站份额所有人，承诺放弃其作为按份共有人对其他财产份额部分的优先购买权。乙方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>可以在丙方同意的情况下，通过丙方平台发布信息，</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>再次</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>转让</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>其</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>持有</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>的电站份额</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>。</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp; </span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第4条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>甲方权利与义务</span></p>
          <p style={ { margin: '0pt 0pt 0pt 21pt', orphans: 0, textIndent: '-1.05pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>1、</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>甲方将其转让的电站项目份额所对应的权利义务一并转让给乙方，权</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>利义务交割时间为</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方支付转让价款之时。</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '21pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>2、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>甲方有权自行确定转让价格。</span><span
            style={ {
              backgroundColor: '#ffffff',
              fontFamily: '仿宋',
              fontSize: '10pt',
              fontWeight: 'bold'
            } }> </span><span style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 21pt', orphans: 0, textIndent: '-1.05pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>3、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>甲方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>保证</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>转让的</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站项目</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>份额</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>不存在任何权利瑕疵（包括但不限于</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>被</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>抵押、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>被</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>质押等），且在电站出让前后均不得作出任何影响电站实质或形式方面的权利处置。</span></p>
          <p style={ {
            margin: '0pt 0pt 0pt 19.95pt',
            orphans: 0,
            paddingLeft: '1.05pt',
            textIndent: '-1.05pt',
            widows: 0
          } }><span style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>4</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>、甲方有权收取转让电站所得转让款（以转让份额为基数，按照未结算的实际持有天数扣除电站运营维护方应收取的管理服务费、其他费用）。</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '20pt', widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第5条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>丙方权利与义务</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>1、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>丙方作为居间方，利用互联网技术为</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>双方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>提供</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>信息发布、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>披露</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>服务</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，撮合甲乙双方达成交易。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>2、</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>丙方应根据《平台服务协议》、《用户注册协议（个人）》的要求对甲方</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>、乙方主体资格作形式审查，丙方可以定期抽查核验甲方、乙方注册数据及电站</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>份额转让</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>行为真实性，有权根据以上协议对违约主体采取相应措施。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>3、</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>丙方有权选择符合要求的银行向甲方、乙方提供银行存管（监管）服务，用于</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>乙方支付份额转让价款</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、售电收益回款、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>电站运营维护方</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>售电收益结算等。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>4</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>丙方应为甲方、乙方提供电站信息数据展示。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第6条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>项目归属</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;&nbsp; </span><span
            style={ {
              backgroundColor: '#ffffff',
              fontFamily: '仿宋',
              fontSize: '10pt'
            } }>乙方受让完成后，乙方按照其受让的份额享有电站产权，电站运营维护方仅代为持有电站并负责运营维护。</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第7条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>争议解决</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 20.9pt', orphans: 0, textIndent: '21.1pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>因本协议的履行、签订均发生于互联网，如发生任何纠纷或争议，首先应友好协商</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>解决；协商不成的，将纠纷或争议提交杭州互联网法院诉讼解决。</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '20.05pt', widows: 0 } }><span
            style={ { fontFamily: '仿宋', fontSize: '10pt' } }>&nbsp;</span></p>
          <p style={ { margin: '0pt', orphans: 0, textIndent: '18.05pt', widows: 0 } }><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt',
            fontWeight: 'bold'
          } }>第8条</span><span style={ { font: '7.0pt "Times New Roman"' } }>&nbsp;&nbsp; </span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt', fontWeight: 'bold' } }>其他</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>1、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>本协议采用电子合同形式</span><span
            style={ {
              backgroundColor: '#ffffff',
              fontFamily: '仿宋',
              fontSize: '10pt',
              fontWeight: 'bold'
            } }>（各方知晓并同意，本协议在签订前已经已预览形式向您展现，您实际履行投资行为即视为同意预览合同条款）</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>，自双方在网页、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>app</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>端在本协议确认页点击确认后即视为协议签署，合同自签署之日起生效。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>2、</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>本协议未尽事宜</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>,</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>各方可另行签署补充协议</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>,</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>该补充协议与本合同是一个不可分割的整体</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>,</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>并与本合同具有同等法律效力。</span></p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, textIndent: '0pt', widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>3、</span><span style={ {
            backgroundColor: '#ffffff',
            fontFamily: '仿宋',
            fontSize: '10pt'
          } }>丙方平台的《平台服务协议》、《用户注册协议（个人）》、为本协议之补充，具有同等法律效力。如有冲突的，以本协议为准。</span>
          </p>
          <p style={ { margin: '0pt 0pt 0pt 18.05pt', orphans: 0, widows: 0 } }><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>4</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>、本协议</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>签订过程将采取时间戳技术</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>或电子存证</span><span
            style={ { backgroundColor: '#ffffff', fontFamily: '仿宋', fontSize: '10pt' } }>等形式予以保留，对各方具有法律约束力。</span></p>
          <p style={ { margin: '0pt', orphans: 0, textAlign: 'justify', widows: 0 } }><span
            style={ { fontFamily: 'Calibri', fontSize: '10.5pt' } }>&nbsp;</span>
          </p>
          <p style={ { margin: '0pt', orphans: 0, textAlign: 'justify', widows: 0 } }><span
            style={ { fontFamily: 'Calibri', fontSize: '10.5pt' } }>&nbsp;</span>
          </p></div>
      </div>
    );
  }
}

export default TransferFile;



// WEBPACK FOOTER //
// ./src/pages/agent/TransferFile/index.js